/**
 * Constants for Auto Apply Setup flow
 */

/**
 * Custom class identifier for remote work type taxonomy concepts.
 * Used to query taxonomy concepts API for remote work options (Fully Remote, Hybrid, On-site).
 * The translated labels are returned based on the user's locale.
 */
export const REMOTE_WORK_TYPE_CUSTOM_CLASS = 'SVU2N';
